import React, { useState, useEffect } from 'react'
import { Form } from 'react-bootstrap'

const TextField = ({ label, onChange, value, placeholder = ''}) => {

  const handleChange = (e) => {
    onChange(e.target.value)
  }

  return (
    <Form.Group className='mr-5'>
      <Form.Label>{label}</Form.Label>
      <Form.Control type='text' value={value} onChange={handleChange} placeholder={placeholder}/>
    </Form.Group>
  )
}

export default TextField